import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/lib/brand";

export default function NavBar({ onJoin, stats }) {
  const allClosed = stats?.all_closed;
  const foundersClosed = stats?.founders_closed;
  const label = allClosed ? "Founding closed" : foundersClosed ? "Buy a Pass" : `Join Founding ${stats?.founders_total ?? 45}`;
  return (
    <header
      className="fixed top-0 inset-x-0 z-40 backdrop-blur-md bg-[#F7F5F0]/80 border-b border-border/60"
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Hontō" className="w-6 h-6 object-contain invert" />
          <span className="font-serif text-xl tracking-tight text-primary leading-none">
            Hontō <span className="italic font-light">Matcha</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-9 text-sm text-muted-foreground">
          <a href="#philosophy" className="hover:text-primary transition-colors" data-testid="nav-philosophy">Philosophy</a>
          <a href="#grades" className="hover:text-primary transition-colors" data-testid="nav-grades">The Grades</a>
          <a href="#menu" className="hover:text-primary transition-colors" data-testid="nav-menu">Menu</a>
          <a href="#pass" className="hover:text-primary transition-colors" data-testid="nav-pass">Matcha Pass</a>
          <a href="#faq" className="hover:text-primary transition-colors" data-testid="nav-faq">FAQ</a>
        </nav>
        <Button
          onClick={onJoin}
          disabled={allClosed}
          data-testid="nav-join-btn"
          className="rounded-full bg-primary text-primary-foreground hover:bg-[#1F382B] disabled:opacity-50 disabled:cursor-not-allowed px-5 h-10 text-xs tracking-wider uppercase"
        >
          {label}
        </Button>
      </div>
    </header>
  );
}
